/* eslint-disable prefer-destructuring */

import { MeiliSearch } from 'meilisearch';

const NEXT_PUBLIC_MEILISEARCH_HOST = process.env.NEXT_PUBLIC_MEILISEARCH_HOST;
const NEXT_PUBLIC_MEILISEARCH_SEARCH_API_KEY = process.env.NEXT_PUBLIC_MEILISEARCH_SEARCH_API_KEY;

export const meilisearch = new MeiliSearch({
    host: NEXT_PUBLIC_MEILISEARCH_HOST,
    apiKey: NEXT_PUBLIC_MEILISEARCH_SEARCH_API_KEY,
});
